import { MONTHLY } from 'self-service-api/constants/Terms';
export const PROMOTION = 'promotion';
export const DISCOUNTED = 'discounted';
export const NEW_CUSTOMER_OFFER = 'new-customer-offer';
export const SUITE_INTERSTITIAL = 'suite-interstitial';
export const DISCOUNTED_KEY_GETTER = {
  [PROMOTION]: term => {
    return term === MONTHLY ? 'promotionPricingPerMonthBilledMonthly_jsx' : 'promotionPricingPerYearAtCost_jsx';
  },
  [DISCOUNTED]: term => {
    return term === MONTHLY ? 'discountedPricingPerMonthBilledMonthly_jsx' : 'discountedPricingPerYearAtCost_jsx';
  },
  [NEW_CUSTOMER_OFFER]: term => {
    return term === MONTHLY ? 'newCustomerOfferPricingPerMonthBilledMonthly_jsx' : undefined;
  },
  [SUITE_INTERSTITIAL]: () => 'startsAtBold_jsx'
};